import jQuery from 'jquery';

jQuery($ => {
    if ($('.teaser--slider').length) {
        require.ensure([], require => {
            const Swiper = require('swiper/dist/js/swiper.jquery.umd');

            $('.teaser--slider').each((index, slider) => {
                let $tabItems = $(slider).find('.teaser__tabs__item'),
                    activeClass = 'is-active',
                    imageSwiper = new Swiper('.teaser__images', {
                        centeredSlides: false,
                        height: 'auto',
                        autoplay: 5000,
                        slidesPerView: 1,
                        autoplayDisableOnInteraction: false,
                        onTransitionStart(swiper) {
                            $tabItems.removeClass(activeClass);
                            $tabItems.eq(swiper.realIndex).addClass(activeClass);
                        }
                    });

                $tabItems.on('click', function (event) {
                    let $item = $(this);

                    if (!$item.is('.' + activeClass)) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        $tabItems.removeClass(activeClass);
                        $item.addClass(activeClass);
                        imageSwiper.slideTo($item.index(), 300, false);
                    }
                });
            });
        }, 'teaser');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/teaser.js